/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
/** @jsx jsx */
import { jsx, Box, Container, Flex } from 'theme-ui';
/* eslint-disable react/no-danger */
import React from 'react';

// Node Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Node Components
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';

// Types
import { CTA } from '../../@types/cta';
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';

// Components
import Text, { TEXT_TYPES } from '../../components/text';
import CTAButton from '../../components/ctaButton';

// Styles
import { baseStyle } from './style';

interface FeaturesProps extends Section {
  title: {
    title: string;
  };
  features: {
    featuresList: {
      featureTitle?: string;
      featureSubSubTitle?: string;
      featureContent?: string;
      featureImage?: ImageType;
      featureCta?: CTA;
    }[];
  };
}

const Features: SectionComponent<any> = React.memo(
  ({ title, features }: FeaturesProps) => {
    // States
    const [selectedTab, setSelectedTab] = React.useState<number>(0);

    const selectedTabTop = React.useMemo(() => selectedTab * 200, [
      selectedTab,
    ]);

    return (
      <Container sx={baseStyle.mainContainer}>
        <Text type={TEXT_TYPES.H2} sx={baseStyle.title} lines="2">
          {title.title}
        </Text>
        <Flex sx={baseStyle.tabsContainer}>
          <Flex sx={baseStyle.tabsContainerLeft}>
            <Box
              sx={{
                ...baseStyle.selectionBar,
                top: `${selectedTabTop}px`,
              }}
            />
            {features.featuresList.map((feature: any, idx: number) => (
              <Flex
                key={idx}
                sx={baseStyle.featureTab}
                onClick={() => setSelectedTab(idx)}
              >
                {feature.featureTitle && (
                  <Text
                    type={TEXT_TYPES.SIDEBAR_H1}
                    sx={baseStyle.featureTitle}
                    lines="2"
                  >
                    {feature.featureTitle}
                  </Text>
                )}
                {feature.featureSubSubTitle && (
                  <Text
                    type={TEXT_TYPES.H4}
                    sx={baseStyle.featureSubtitle}
                    lines="2"
                  >
                    {feature.featureSubSubTitle}
                  </Text>
                )}
              </Flex>
            ))}
          </Flex>
          <Box sx={baseStyle.tabsContainerRight}>
            {features.featuresList.map((feature: any, idx: number) => (
              <Box
                key={idx}
                sx={{
                  ...baseStyle.featureContentContainer,
                  opacity: selectedTab === idx ? '1' : '0',
                  pointerEvents: selectedTab === idx ? 'initial' : 'none',
                  position: selectedTab === idx ? 'relative' : 'absolute',
                }}
              >
                {feature.featureImage && (
                  <FluidImage
                    {...feature.featureImage}
                    sx={baseStyle.featureImage}
                  />
                )}
                {feature.featureContent && (
                  <Text
                    type={TEXT_TYPES.BODY_INTRO}
                    sx={baseStyle.featureContent}
                    lines="6"
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: feature.featureContent,
                      }}
                    />
                  </Text>
                )}
                <CTAButton
                  type="link"
                  cta={feature.featureCta}
                  sx={baseStyle.featureCta}
                >
                  {feature.featureCta.label}
                </CTAButton>
              </Box>
            ))}
          </Box>
        </Flex>
      </Container>
    );
  },
);

export default Features;
